import { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import ComboBox from "../core/ComboBox";

const ProjectComboBoxSelect = ({
  projects = [],
  selectedProjectId,
  onSelect,
  showComboBox,
  onToggle,
  onClose,
  emptyLabel = "Select a project",
  error = false,
  triggerId,
}) => {
  const containerRef = useRef(null);
  const selectedProject = projects.find(
    (project) => String(project.project_id) === String(selectedProjectId)
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    if (showComboBox) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showComboBox, onClose]);

  const handleSelect = (projectId) => {
    onSelect(projectId);
    onClose();
  };

  return (
    <div ref={containerRef} style={{ position: "relative" }}>
      <div
        id={triggerId}
        role="button"
        tabIndex={0}
        className={`form-control ${error ? "is-invalid" : ""}`}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
        }}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <span
          style={{
            color: selectedProject
              ? "var(--input-color)"
              : "var(--input-disabled-color, #999)",
            flex: 1,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            minWidth: 0,
          }}
        >
          {selectedProject && (
            <span
              style={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor:
                  selectedProject.color || "var(--border-color)",
                border: "1px solid rgba(0, 0, 0, 0.15)",
                flexShrink: 0,
              }}
            />
          )}
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {selectedProject?.name ?? emptyLabel}
          </span>
        </span>
        <FontAwesomeIcon
          icon={faChevronDown}
          style={{
            color: "var(--input-color)",
            fontSize: "0.75rem",
            marginLeft: "8px",
            flexShrink: 0,
            transition: "transform 0.2s",
            transform: showComboBox ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </div>
      {showComboBox && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1050,
            marginTop: "4px",
          }}
        >
          <ComboBox
            data={projects}
            selected={selectedProject ? [selectedProject] : []}
            valueKey="project_id"
            placeholder="Search projects..."
            searchTopic="project"
            formatData={(project) => project.name}
            handleSelect={handleSelect}
            onRequestClose={onClose}
            inline={false}
            sortKey="name"
          />
        </div>
      )}
    </div>
  );
};

export default ProjectComboBoxSelect;
